import { manufacturingFetch } from "@/lib/manufacturingClient";

/**
 * Client API + types for the post-Admin-split anchor-entitlements endpoint.
 *
 * The fetch reuses `manufacturingFetch` from `manufacturingClient.ts` because
 * the wire pattern (Bearer + `X-Workspace-Organization-Id`) is identical — the
 * function name is legacy; behavior is generic. When a future slice carves the
 * generic wrapper out of `manufacturingClient`, this import flips with no
 * call-site change here.
 *
 * Endpoint contract lives in `server/entitlementAnchorsHandler.ts`; the
 * routing rewrite is in `vercel.json`.
 */

export type AnchorKey = "turbo_sales" | "turbo_manufacturing";

export type AnchorEntitlements = {
  turbo_sales: boolean;
  turbo_manufacturing: boolean;
  turbo_sign: boolean;
  /** Paid Coverage add-on. Not implied by either anchor. */
  coverage: boolean;
};

export type AnchorEntitlementsResponse = {
  ok: true;
  organization_id: string;
  anchors: AnchorEntitlements;
  active_addon_keys: string[];
};

/** Empty / not-yet-loaded sentinel. */
export const NO_ANCHOR_ENTITLEMENTS: AnchorEntitlements = {
  turbo_sales: false,
  turbo_manufacturing: false,
  turbo_sign: false,
  coverage: false,
};

export function getAnchorEntitlements() {
  return manufacturingFetch<AnchorEntitlementsResponse>("/api/entitlements/anchors", {
    method: "GET",
  });
}

/** Does the org satisfy at least one anchor entitlement? */
export function hasAnyAnchor(anchors: AnchorEntitlements | null | undefined): boolean {
  if (!anchors) return false;
  return anchors.turbo_sales || anchors.turbo_manufacturing;
}
